import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolderArrowUp20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFolderArrowUp20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.623 4.5H4a.5.5 0 0 0-.5.5v1h6.616l-1.11-1.321a.5.5 0 0 0-.383-.179M2 5v10.5A2.5 2.5 0 0 0 4.5 18h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 6h-3.426l-1.919-2.286A2 2 0 0 0 8.623 3H4a2 2 0 0 0-2 2m9.375 2.5H15.5a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-8zm.906 4.78a.75.75 0 0 1-1.061 0l-.47-.47v2.39a.75.75 0 0 1-1.5 0v-2.425l-.505.505a.75.75 0 0 1-1.06-1.06l1.767-1.768.53-.53.53.53 1.768 1.768a.75.75 0 0 1 0 1.06"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFolderArrowUp20);
